import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  associateListPanel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    backgroundColor: "rgba(28, 30, 31)",
    minHeight: 960,
    width: "100%",
    borderRadius: 24,
    border: "1px solid #000000",
    padding: "24px 48px",
    overflowX: "auto",
    fontFamily: "Philosopher",

    [theme.breakpoints.down("lg")]: {
      padding: "4px 16px",
      alignItems: "flex-start",
      minHeight: 720,
    },
  },

  associateListHeader: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    padding: "16px 16px",
    width: "100%",
    boxSizing: "border-box",
    minWidth: "900px",

    [theme.breakpoints.down("sm")]: {
      gap: 8,
      minWidth: 600,
      fontSize: 12,
    },

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF40",

      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
      },
    },
  },

  listItem: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    alignItems: "center",
    padding: "16px 16px",
    width: "100%",
    boxSizing: "border-box",
    borderBottom: "1px solid #FFFFFF10",
    minWidth: "900px",
    color: "white",

    [theme.breakpoints.down("sm")]: {
      gap: 8,
      minWidth: 600,
      fontSize: 12,
    },

    "& a": {
      textDecoration: "none",
      color: theme.palette.text.linkColor,
      fontFamily: "Philosopher",
      fontWeight: 900,
    },

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",

      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
      },
    },
  },

  selected: {
    backgroundColor: " #FFFFFF10",
  },

  statusBox: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },

  nameBox: {
    color: "#1c7995",
  },
}));

export default styles;
